module.exports = __webpack_public_path__ + "assets/img/erweima-wx.970dad6b.jpg";